import { css } from '@emotion/react';
import colors from '../../../Themes/colors';

const { black, white, orange } = colors;

export const modalWrapper = css({
    '@media(min-width: 300px)': {

        '>div': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 12,
            border: 'none',
            '>div': {
                width: '100%',
                borderRadius: 12,
                backgroundColor: 'white',
                padding: 30,
                form: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    '>div': {
                        width: '100%',
                    },
                },
            },
        },
    },

    '@media(min-width: 1200px)': {
        '>div': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'none',
            '>div': {
                width: '50%',
                borderRadius: 12,
                backgroundColor: 'white',
                padding: 60,
                paddingTop: 30,
                paddingBottom: 30,
                form: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    '>div': {
                        width: '100%',
                    },
                },
            },
        },
    },
});

export const sendEmailModalWrapper = css({
    '@media(min-width: 300px)': {
        '>div': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'none',
            border: 'none',
            borderRadius: 12,
            height: '80vh',
            '>div': {
                width: '100%',
                borderRadius: 12,
                backgroundColor: 'white',
                padding: 30,
            },
        },
    },
});

export const modalHeaderContainer = css({
    '& p': {
        margin: 0,
    },

    '& .title': {
        paddingBottom: 15,
        fontSize: '2.4rem',
        fontFamily: 'Playfair',
        fontWeight: 700,
        color: '#064E72',
    },

    '& .text': {
        paddingBottom: 15,
        fontSize: '1.4rem',
        fontFamily: 'AcuminRPro',
        color: 'black',
    },
});

export const modalSignupWrapper = css({
    '> div': {
        display: 'flex',
        backgroundColor: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
    },
});

export const modalContainer = css({

    '@media(min-width: 300px)': {
        width: '100%',
        height: 'auto',
        padding: 35,
        backgroundColor: 'white',
        borderRadius: 12,
    },
    '@media(min-width: 1200px)': {
        width: '80%',
        padding: 60,
        backgroundColor: 'white',
        borderRadius: 12,
    },
});

export const inputContainer = css({
    wdith: '100%',
    marginBottom: 20,
    '& p': {
        fontSize: '1.4rem',
        fontFamily: 'AcuminRPro',
    },
    '& input': {
        fontSize: '1.4rem',
        fontFamily: 'AcuminRPro',
    },
});

export const datePickerContainer = css({
    // width: '100% !important',

    // '@media(min-width: 300px)': {
    //     '& .react-datepicker': {
    //         width: '90% !important',
    //         // '& div': {
    //         //     width: '100% !important',
    //         // },

    //         '& .react-datepicker__header': {
    //             width: 'auto !important',
    //             height: '5rem !important',
    //             '& div': {
    //                 width: 'auto !important',
    //                 '& div': {
    //                     width: '20% !important',
    //                 },
    //             },
    //         },
    //         '& .react-datepicker__month': {
    //             width: 'auto !important',
    //             '& .react-datepicker__week': {
    //                 width: 'auto !important',
    //                 '& div': {
    //                     width: '20% !important',
    //                 },
    //             },
    //         },
    //     },
    // },

    // '@media(min-width: 1200px)': {
    //     '& .react-datepicker': {
    //         width: '80% !important',
    //         '& div': {
    //             width: '100% !important',
    //         },

    //         '& .react-datepicker__header': {
    //             width: 'auto !important',
    //             '& div': {
    //                 width: 'auto !important',
    //                 '& div': {
    //                     width: '10% !important',
    //                 },
    //             },
    //         },
    //         '& .react-datepicker__month': {
    //             width: 'auto !important',
    //             '& .react-datepicker__week': {
    //                 width: 'auto !important',
    //                 '& div': {
    //                     width: '10% !important',
    //                 },
    //             },
    //         },
    //     },
    // },
});

export const flexHiddenContainer = css({
    '@media(min-width: 300px)': {
        // display: 'flex',
        // justifyContent: 'space-between',
        // gap: 0,
    },

    '@media(min-width: 1200px)': {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 20,
        marginBottom: 10,
        '& div': {
            height: 'auto',
            margin: 0,
        },
    },
});

export const LoginContainer = css({
    display: 'flex',
    flexDirection: 'column-reverse',
    '@media(min-width: 1000px)': {
        display: 'flex',
        flexDirection: 'row',
    },
});

export const leftContainer = css({
    background: 'linear-gradient(180deg, #BF7247 0%, #DBAA8D 100%)',
    height: '700px',
});

export const rightContainer = css({});

export const ContainerAlignCenter = css({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
});

export const leftTitle = css({
    fontSize: '2.4rem',
    fontFamily: 'Playfair',
    fontWeight: 700,
    color: '#064E72',
    marginBottom: '30px',
    '@media(min-width: 1200px)': {
        marginBottom: '20px',
    },
});

export const InputStyle = css({
    width: '100%',
    fontSize: '14px',
    // color: '#949494',
    color: 'black',
    borderRadius: 12,

    ':: placeholder': {
        display: 'none',
        color: '#B7916A',
    },

    '@media(min-width: 1200px)': {
        ':: placeholder': {
            display: 'block',
            color: '#B7916A',
        },
        // width: '65%',
        height: 'auto',
        fontSize: '1.4rem',
        paddingTop: 20,
        paddingBottom: 10,
        paddingLeft: 20,
        paddingRight: 20,
    },
});

export const CheckBoxContainer = css({
    display: 'flex',
    marginTop: '20px',
    marginBottom: '20px',
    alignItems: 'center',
    width: 'auto',
    font: '12px AcuminRPro, serif',
    color: 'black',

    '@media(min-width: 1200px)': {
        width: '65%',
        font: '15px AcuminRPro, serif',
    },
});

export const ButtonStyleLeft = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '65%',
    font: '18px Archivo-Regular, sans-serif',
    fontWeight: '500',
    color: 'white',
    background: '#064E72',
    borderColor: black,
    borderRadius: 8,
    marginTop: '10px',
    padding: '13px 0px',
    paddingRight: '20px',
    gap: 10,
    '&:hover': {
        background: white,
        borderColor: '#064E72',
        color: '#064E72',

        '& .arrowWhite': {
            display: 'none',
        },
        '& .arrowBlue': {
            display: 'block',
        },
    },
    '& .arrowBlue': {
        display: 'none',
        width: 25,
        height: 25,
    },
    '& .arrowWhite': {
        display: 'block',
        width: 25,
        height: 25,
    },
});

export const CloseContainer = css({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingTop: '20px',
    paddingRight: '20px',
});

export const RightTitle = css({
    font: '25px Archivo-Regular, serif',
    fontWeight: '700',
    color: black,
    marginTop: '30px',
    marginBottom: '30px',
    '@media(min-width: 1200px)': {
        font: '35px Archivo-Regular, serif',
        marginTop: '50px',
        marginBottom: '50px',
    },
});

export const CheckBoxContainerRight = css({
    fontSize: '1.4rem',
    fontFamily: 'AcuminRPro',
    color: black,
    display: 'flex',
    alignItems: 'center',
    width: '80%',
    '@media(min-width: 1200px)': {
        width: '64%',
    },
});

export const CheckBoxOuterContainerRight = css({
    alignItems: 'center',
    width: '90%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
});

export const ForgotPasswordStyle = css({
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontSize: '1.2rem',
    fontFamily: 'AcuminRPro',
    fontWeight: 500,
    color: '#064E72',
    textDecorationLine: 'underline',
});

export const ButtonStyleRight = css({
    width: '65%',
    borderColor: white,
    '&:hover': { background: white, borderColor: '#064E72', color: '#064E72' },
    marginTop: '40px',
    marginBottom: '40px',
});

export const checkoutAsGuestButton = css({

    display: 'block',
    font: '18px AcuminRPro',
    color: '#064E72',
    backgroundColor: 'white',
    border: '2px solid #064E72',
    borderRadius: '12px',
    width: '100%',
    height: 55,
    marginTop: '40px',
    transition: 'ease 0.2s',
    fill: colors.white,

    '& svg': {
        color: 'transparent',
        fill: 'transparent',
    },

    '&:hover svg': {
        color: '#064E72',
        fill: '#064E72',
    },
    '&:hover': {
        border: '2px solid #E6DFD8',
        backgroundColor: '#BCBEC0',
        color: '#064E72',
    },
    '&:focus': {
        color: '#064E72',
        backgroundColor: colors.white,
        border: '2px solid #E6DFD8',
    },
    '&:active': {
        color: '#064E72',
        backgroundColor: colors.white,
        border: '2px solid #E6DFD8',
    },

    '@media(min-width:992px)': {
        width: '100%',
        fontSize: '18px',
    },
});

export const nestedSignupModal = css({
    // background: 'linear-gradient(180deg, #BF7247 0%, #DBAA8D 100%)',
    // backgroundColor: 'red',
    // borderRadius: 20,
});

export const nestedSignupModalTitle = css({
    font: '25px Archivo-Regular, serif',
    fontWeight: '700',
    color: '#064E72',
    marginTop: '10px',
    marginBottom: '10px',
    '@media(min-width: 1200px)': {
        font: '35px Archivo-Regular, serif',
        marginTop: '15px',
        marginBottom: '15px',
    },
});

export const nestedSignupModalInput = css({
    width: '100%',
    color: 'black',
    height: '48px',
    borderRadius: 12,
    fontSize: '1.4rem',
    fontFamily: 'AcuminRPro',
    '::placeholder': {
        color: '#B7916A',
    },
    '@media(min-width: 1200px)': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        fontSize: '1.4rem',
        fontFamily: 'AcuminRPro',
        height: 50,
        paddingTop: 10,
        paddingLeft: 20,
        paddingRight: 20,
    },
});

export const nestedSignupModalSubmitButton = css({
    '@media(min-width: 300px)': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        font: '18px Archivo-Regular, sans-serif',
        fontWeight: '500',
        color: white,
        background: '#064E72',
        borderColor: white,
        borderRadius: 12,
        padding: '18px 0px',
        '&:hover': { background: white, borderColor: '#064E72', color: '#064E72' },
        margin: 0,
        marginTop: 15,
        gap: 5,
        '& img': {
            marginTop: -5,
            width: 25,
            height: 25,
        },
    },

    '@media(min-width: 1200px)': {
        font: '18px Archivo-Regular, sans-serif',
        fontWeight: '500',
        color: white,
        background: '#064E72',
        borderColor: white,
        borderRadius: 12,
        padding: '18px 0px',
        '&:hover': { background: white, borderColor: '#064E72', color: '#064E72' },
        marginTop: '5px',
    },

});

export const loginInput = css({
    width: '80%',
    font: '14px Archivo-Regular, serif',
    color: '#949494',
    padding: '0px 12px',
    marginBottom: '25px',
    '@media(min-width: 1200px)': {
        width: '65%',
        font: '16px Archivo-Regular, serif',
    },
});

export const formGroupCss = css({
    display: 'flex',
    textAlign: 'start',
    justifyContent: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
    fontSize: '1.4rem',
    fontFamily: 'AcuminRPro',
});

export const signUpError = css({
    color: 'white',
});
